<template lang="pug">
  div#grafico-detalhe__main-container
    h3#grafico-detalhe__titulo {{dados.numeroOS}}
    div#grafico-detalhe__container-body
      div#grafico-detalhe__container-cards-grafico
        div(
          v-for="(tecnico, idx) in dados.tecnicos"
          :key="tecnico.idOS"
          :id="[`grafico-detalhe__card-grafico-${idx + 1}`]"
        ).unit-card.card
          vc-donut(
            v-bind="getFormattedData(tecnico)"
            @section-mouseover="displaySectionValue"
            @section-mouseleave="resetSectionValue"
            @section-mousemove="displaySectionValueOnOver"
            @section-mouseout="resetSectionValue"
          )
          h4 {{tecnico.nomeTecnico}}
          h5 {{tecnico.funcaoTecnico}}
      div#grafico-detalhe__container-legenda
        div#grafico-detalhe__card-legenda.card
          p Legenda
          .row
            div(:style="{'background-color': AGUARDANDO_ANALISE_PROCESSO_PAI.cor}").quadrado
            span {{AGUARDANDO_ANALISE_PROCESSO_PAI.nome}}
          .row
            div(:style="{'background-color': AGUARDANDO_ANALISE.cor}").quadrado
            span {{AGUARDANDO_ANALISE.nome}}
          .row
            div(:style="{'background-color': EM_ANALISE.cor}").quadrado
            span {{EM_ANALISE.nome}}
          .row
            div(:style="{'background-color': EM_REVISAO.cor}").quadrado
            span {{EM_REVISAO.nome}}
          .row
            div(:style="{'background-color': FINALIZADO.cor}").quadrado
            span {{FINALIZADO.nome}}
</template>
<script>
export default {
  props: {
    dados: {
      required: true
    }
  },

  data () {
    return {
      AGUARDANDO_ANALISE_PROCESSO_PAI: {
        codigo: 'AGUARDANDO_ANALISE_PROCESSO_PAI',
        nome: 'Aguardando processo chegar para o técnico de campo',
        cor: '#68BE8D'
      },

      AGUARDANDO_ANALISE: {
        codigo: 'AGUARDANDO_ANALISE',
        nome: 'Aguardando análise',
        cor: '#6B7B6E'
      },

      EM_ANALISE: {
        codigo: 'EM_ANALISE',
        nome: 'Em análise',
        cor: '#BED3CA'
      },

      EM_REVISAO: {
        codigo: 'EM_REVISAO',
        nome: 'Em revisão',
        cor: '#98D98E'
      },

      FINALIZADO: {
        codigo: 'FINALIZADO',
        nome: 'Finalizado',
        cor: '#47885E'
      }
    }
  },

  methods: {
    getFormattedData (tecnico) {
      const graphProps = {
        size: 150,
        thickness: 35,
        sections: [],
        total: 0,
        text: ''
      }

      graphProps.sections.push({
        label: this.AGUARDANDO_ANALISE_PROCESSO_PAI.nome,
        value: this.aguardandoAnalisePai(tecnico),
        color: this.AGUARDANDO_ANALISE_PROCESSO_PAI.cor,
        total: this.total(tecnico)
      })

      graphProps.sections.push({
        label: this.AGUARDANDO_ANALISE.nome,
        value: this.aguardandoAnalise(tecnico),
        color: this.AGUARDANDO_ANALISE.cor,
        total: this.total(tecnico)
      })

      graphProps.sections.push({
        label: this.EM_ANALISE.nome,
        value: this.emAnalise(tecnico),
        color: this.EM_ANALISE.cor,
        total: this.total(tecnico)
      })

      graphProps.sections.push({
        label: this.EM_REVISAO.nome,
        value: this.emRevisao(tecnico),
        color: this.EM_REVISAO.cor,
        total: this.total(tecnico)
      })

      graphProps.sections.push({
        label: this.FINALIZADO.nome,
        value: this.concluido(tecnico),
        color: this.FINALIZADO.cor,
        total: this.total(tecnico)
      })

      graphProps.total = this.total(tecnico)
      graphProps.text = `${this.total(tecnico)}`

      return graphProps
    },

    aguardandoAnalisePai (prop) {
      let total = 0

      prop.processos.forEach(item => {
        if (
          item.status.codigo === this.AGUARDANDO_ANALISE_PROCESSO_PAI.codigo
        ) {
          total = item.quantidade
        }
      })

      return total
    },

    aguardandoAnalise (prop) {
      let total = 0

      prop.processos.forEach(item => {
        if (item.status.codigo === this.AGUARDANDO_ANALISE.codigo) {
          total = item.quantidade
        }
      })

      return total
    },

    emAnalise (prop) {
      let total = 0

      prop.processos.forEach(item => {
        if (item.status.codigo === this.EM_ANALISE.codigo) {
          total = item.quantidade
        }
      })

      return total
    },

    emRevisao (prop) {
      let total = 0

      prop.processos.forEach(item => {
        if (item.status.codigo === this.EM_REVISAO.codigo) {
          total = item.quantidade
        }
      })

      return total
    },

    concluido (prop) {
      let total = 0

      prop.processos.forEach(item => {
        if (item.status.codigo === this.FINALIZADO.codigo) {
          total = item.quantidade
        }
      })
      return total
    },

    total (prop) {
      let total = 0

      prop.processos.forEach(item => {
        total += item.quantidade
      })

      return total
    },

    displaySectionValue (section, evt) {
      const valorCentral = evt.relatedTarget.querySelector('.cdc-text')
      if (valorCentral) {
        valorCentral.textContent = section.value
      }
    },

    resetSectionValue (section, evt) {
      const valorCentral = evt.relatedTarget.querySelector('.cdc-text')
      if (valorCentral) {
        valorCentral.textContent = section.total
      }
    },

    displaySectionValueOnOver (section, evt) {
      let valorCentral

      if (evt.path) { // chrome
        valorCentral = evt.path[5].querySelector('.cdc-text')
      } else { // firefox
        valorCentral =
          evt
            .originalTarget
            .offsetParent
            .offsetParent
            .nextElementSibling
            .querySelector('.cdc-text')
      }

      valorCentral.innerHTML = section.value
    }
  }
}
</script>

<style lang="scss" scoped>
.row,
#grafico-detalhe__container-body {
  display: flex;
}

#grafico-detalhe__container-body {
  justify-content: space-between;
  padding-bottom: 23px;
}

#grafico-detalhe__container-cards-grafico {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(auto-fill, 1fr);
  gap: 25px 50px;
  margin-right: 30px;
}

#grafico-detalhe__container-cards-grafico >>> .cdc-text {
  font-size: 2rem !important;
}

.unit-card {
  width: 300px;
  height: 300px;
  padding: 20px 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  h4,
  h5 {
    text-align: center;
    margin: 15px auto !important;
  }

  h4 {
    height: 60px;
  }
}

.quadrado {
  min-width: 15px;
  min-height: 15px;
  margin-right: 10px;
}

.row {
  height: 55px;
  align-items: center;

  span {
    font-size: 0.85rem;
  }
}

#grafico-detalhe__card-legenda {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 25px;

  p {
    text-align: center;
  }
}

#grafico-detalhe__card-grafico-1,
#grafico-detalhe__card-grafico-2 {
  grid-row: 1/1;
}

#grafico-detalhe__card-grafico-3,
#grafico-detalhe__card-grafico-4 {
  grid-row: 2/2;
}

#grafico-detalhe__card-grafico-5,
#grafico-detalhe__card-grafico-6 {
  grid-row: 3/3;
}

#grafico-detalhe__card-grafico-7,
#grafico-detalhe__card-grafico-8 {
  grid-row: 4/4;
}

#grafico-detalhe__card-grafico-9,
#grafico-detalhe__card-grafico-10 {
  grid-row: 5/5;
}

#grafico-detalhe__card-grafico-1,
#grafico-detalhe__card-grafico-3,
#grafico-detalhe__card-grafico-5,
#grafico-detalhe__card-grafico-7,
#grafico-detalhe__card-grafico-9 {
  grid-column: 1/1;
}

#grafico-detalhe__card-grafico-2,
#grafico-detalhe__card-grafico-4,
#grafico-detalhe__card-grafico-6,
#grafico-detalhe__card-grafico-8,
#grafico-detalhe__card-grafico-10 {
  grid-column: 2/2;
}

#grafico-detalhe__container-cards-grafico >>> .cdc-filler:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/GraficoDetalheOS.vue